import axios from 'axios';

export default {

  /**
   *
   * @param code
   * @returns {Promise<unknown>}
   */
  wxLogin(code) {
    return new Promise(function(resolve, reject) {
      axios
        .get('https://oas.wx.dishida.net/biz/wx-login', {
          params: {
            code: code
          }
        })
        .then((response) => {
          const rs = response.data;
          if (!('success' in rs)) rs.success = rs.code === 200;
          if (!('result' in rs)) rs.result = rs.data;
          if (rs.success) {
            resolve({ response: response, success: true, data: rs.data });
          } else {
            resolve({ response: response, success: false, data: rs.data });
          }
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }
};
